<div style="width:100%;" id="preview_body">
    <div class="preview_body"  style="display:flex; justify-content:center;">
        <div class="grid-container" style="width:100%; " #gridContainer
            [style.grid-template-columns]="data.length > 1 ? gridTempleteColumns : '100% 50%'" [ngStyle]="{ 'display': data.length == 1 ? 'grid' : 'grid' }">
            <!-- [ngStyle]="{ 'max-height': data.length == 1 ? '25.75rem' : '13rem','width': data.length == 1 ? '98%' : 'auto','margin-left': data.length == 1 ? '1%' : '0%'}" -->
        
            <div class="grid_item" [attr.grid_index]="i" [attr.page_index]="pageCount" id="grid_item_{{i}}"
                *ngFor="let item of data;index as i">

                <ng-container *ngIf="item.previewChartPostion==-1">
                    <div class="no_chart">
                        <p>No chart configured</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="item.previewChartPostion!=-1">
                    <div class="itemHeader">
                        <p class="itemName">{{ item.widget_name}}</p>
                        <div class="itemIcon" *ngIf="!hideCharts">
                            <!-- <app-output-icons style="width:100%; display:flex;justify-content: end;" [widgetName]="item.item1.widgetName"
                                [visualization]="item.item1.visualization" [id]="i" [infoIcon]="item.item1.infoIcon"
                                [data]="item.item1.metric" [trendData]="item.item2.metric" [sort]="item.item1.sort" [isSort]="item.item1.isSort" [sortToggleFromParent]="sortToggle"
                                (iconClicked)="ClickedIconFun($event)" [item]="item.item1" (sortType)="sortWidget($event)" (defaultSortType)="defaultSortWidget($event)"></app-output-icons> -->
                            <app-custom-output-icons [data]="item" [alldata]="data" (elementClickedStatus)="elementClickedStatus($event)" [widgetchartname]="item.widgetchart_name" [id]="+(i.toString()+pageCount.toString())" [datafromLayout]="datafromLayout"></app-custom-output-icons>
                        </div>
                    </div>
                    <hr>
                    <div class="chart-section" *ngIf="item.metric.length!=0 && item.metric[0].metric_value.length>0 && item.noData!=true && !(_configService.selectedSnapshotType.toLowerCase().includes('multi') && data.length==1 && (item.widgetchart_name=='FUNNEL CHART' || item.widgetchart_name=='Line Chart'))">
                        <!-- <ng-container> -->
                        <!-- <app-snapshot-chartsparent *ngIf="item.item1.metric.length>0 && showChart" [snapProduct]="'custom'" [chart]="item.item1.visualization" [id]="i" [data]="item.item1.metric"
                            [height]="height" [sort]="item.item1.sort" [WidgetDetails]="item.item1"></app-snapshot-chartsparent>
                        -->
                        <app-snapshot-chartsparent [snapProduct]="'custom'" [isOutput]="true"
                            [customData]="item" [gridTempleteColumns]="gridTempleteColumns" [id]="+(i.toString()+pageCount.toString())" [height]="data.length === 1?'22em':'11em'" [widgetCount]="data.length"></app-snapshot-chartsparent>
                    </div>
                    <div class="chart-section" *ngIf="data.length==1 && (item.widgetchart_name=='FUNNEL CHART' || item.widgetchart_name=='Line Chart') && _configService.selectedSnapshotType.toLowerCase().includes('multi')">
                        <div class="grid-container-multiFunnel">
                            <div class="grid-item-multiFunnel" [ngStyle]="{'width': (i % 3 === 0) ? 'auto' : 'auto'}"
                                *ngFor="let cell of gridData;let i=index">
                                <h3 style="font-size: 0.9em;">{{cell.header}}</h3>
                                <hr>
                                <!-- <app-snapshot-chartsparent [snapProduct]="'custom'"  style="width: 98%; height: 100%;"
                              [customData]="customData" [isOutput]="false" [popUp]="true"  [height]="'10em'"></app-snapshot-chartsparent> -->
                                <app-funnelchart1-custom *ngIf="item.widgetchart_name=='FUNNEL CHART' || item.widgetchart_name=='Line Chart'"
                                    [selectedBrand]="cell.header" [isOutput]="true" [multiFunnelPopup]="true"
                                    [popUp]="false" [customData]="cell.data" [id]="i+90" [height]="'9em'"
                                    [gridTempleteColumns]="''" [showXaxisLabels]="i%3==0?true:false"></app-funnelchart1-custom>
                            </div>
                        </div>
                    </div>
                    <div class="chart-section-text" *ngIf="item.metric.length==0 || item.metric[0].metric_value.length<1">
                        <!-- <div *ngIf="item.item1.metric.length<1 && item.item1.noData==undefined">Widget is not configured.</div> -->
                        <div *ngIf="item.metric.length==0 || item.metric[0].metric_value.length<1 || item.noData==true">No data available for the selection.</div>
                    </div>
                </ng-container>


            </div>
     

        </div>
        <!-- <div style="height:100%;width:5%;" *ngIf="datafromLayout.length>1" id="pagination-div">
            
            <div style="position:relative;top:33.5%;left:25%;" >
                <div class="leftPageDiv" (click)="Paginate('left')" [ngClass]="{'disabled':disableLeftClick}">
                    <span class="material-symbols-outlined leftPageClick">arrow_circle_left</span>
                </div>
                <div class="rightPageDiv" (click)="Paginate('right')" [ngClass]="{'disabled':disableRightClick}">
                    <span class="material-symbols-outlined rightPageClick">arrow_circle_right</span>
                </div>
            </div>
        </div> -->
    </div>
</div>